module.exports = __webpack_public_path__ + "assets/16d23ca8ecc43a060e2615e10b47b742.jpg";